//@ts-check
import React from 'react';

/** @type {React.FC<{children:React.ReactNode}>} */
export const CardContainerComplete = ({ children }) => {
  return (
    <div className="bg-white dark:bg-[#001B3D] flex flex-col
     dark:[&_*]:text-gray-50 [&_span]:text-[16px]
     w-auto md:w-[740px] lg:w-[940px] xl:w-[1000px] h-full shadow-md rounded overflow-hidden">
      {children}
    </div>
  );
};
